export const shipmentTypes = {
  GET_SHIPMENT_NUMBERS_LIST_SUCCESS: "GET_SHIPMENT_NUMBERS_LIST_SUCCESS",
  GET_SHIPMENT_NUMBERS_LIST_ERROR: "GET_SHIPMENT_NUMBERS_LIST_ERROR",
  GET_SHIPMENT_PARTNERS: "GET_SHIPMENT_PARTNERS",
  GET_SHIPMENT_PARTNERS_ERROR: "GET_SHIPMENT_PARTNERS_ERROR",
  CREATE_SHIPMENT_LOADING: "CREATE_SHIPMENT_LOADING",

  CREATE_SHIPMENT: "CREATE_SHIPMENT",
  CREATE_SHIPMENT_ERROR: "CREATE_SHIPMENT_ERROR",
  CLEAR_SHIPMENT_ERROR: "CLEAR_SHIPMENT_ERROR",
  CLEAR_SHIPMENT_RESPONSE: "CLEAR_SHIPMENT_RESPONSE",

  SHIPMENT_RESET_STATE: "SHIPMENT_RESET_STATE",

  CANCEL_SHIPMENT_LOADING: "CANCEL_SHIPMENT_LOADING",
  CANCEL_SHIPMENT_SUCCESS: "CANCEL_SHIPMENT_SUCCESS",
  CANCEL_SHIPMENT_ERROR: "CANCEL_SHIPMENT_ERROR",
  CANCEL_SHIPMENT_RESET: "CANCEL_SHIPMENT_RESET",

  GET_SHIPMENT_HUB_PARTNERS: "GET_SHIPMENT_HUB_PARTNERS",
  GET_SHIPMENT_HUB_PARTNERS_ERROR: "GET_SHIPMENT_HUB_PARTNERS_ERROR",

  GET_PENDING_SHIPMENT_DATA_SUCCESS: "GET_PENDING_SHIPMENT_DATA_SUCCESS",
  GET_PENDING_SHIPMENT_DATA_ERROR: "GET_PENDING_SHIPMENT_DATA_ERROR",

  GET_IN_PROGRESS_SHIPMENT_DATA_SUCCESS: "GET_IN_PROGRESS_SHIPMENT_DATA_SUCCESS",
  GET_IN_PROGRESS_SHIPMENT_DATA_ERROR: "GET_IN_PROGRESS_SHIPMENT_DATA_ERROR",

  GET_SHIPMENT_CARGOS_LOADING: "GET_SHIPMENT_CARGOS_LOADING",
  GET_SHIPMENT_CARGOS_SUCCESS: "GET_SHIPMENT_CARGOS_SUCCESS",
  GET_SHIPMENT_CARGOS_ERROR: "GET_SHIPMENT_CARGOS_ERROR",

  EDIT_SHIPMENT_LOADING: "EDIT_SHIPMENT_LOADING",
  EDIT_SHIPMENT_SUCCESS: "EDIT_SHIPMENT_SUCCESS",
  EDIT_SHIPMENT_ERROR: "EDIT_SHIPMENT_ERROR",
  CLEAR_EDIT_SHIPMENT_DATA: "CLEAR_EDIT_SHIPMENT_DATA",

  REMOVE_CARGO_FROM_SHIPMENT_LOADING: "REMOVE_CARGO_FROM_SHIPMENT_LOADING",
  REMOVE_CARGO_FROM_SHIPMENT_SUCCESS: "REMOVE_CARGO_FROM_SHIPMENT_SUCCESS",
  REMOVE_CARGO_FROM_SHIPMENT_ERROR: "REMOVE_CARGO_FROM_SHIPMENT_ERROR",
  CLEAR_REMOVE_CARGO_FROM_SHIPMENT_DATA: "CLEAR_REMOVE_CARGO_FROM_SHIPMENT_DATA",
}